import { ModalWidth } from "~/shared/enums";

type DefinedModalWidths = Exclude<ModalWidth, ModalWidth.FULL | ModalWidth.CUSTOM>;
type UndefinedModalWidths = ModalWidth.FULL | ModalWidth.CUSTOM;

const MODAL_WIDTH_MAP: Record<DefinedModalWidths, number> & Record<UndefinedModalWidths, undefined> = {
  [ModalWidth.XS]: 238,
  [ModalWidth.S]: 400,
  [ModalWidth.M]: 512,
  [ModalWidth.L]: 672,
  [ModalWidth.XL]: 800,
  [ModalWidth.XXL]: 1152,
  [ModalWidth.XXXL]: 1600,
  [ModalWidth.FULL]: undefined,
  [ModalWidth.CUSTOM]: undefined,
};

export default MODAL_WIDTH_MAP;
